import { useState, useMemo } from 'react';
import Card from '../card/Card';
import './PaginatedCards.scss';

const ITEMS_PER_LOAD = 15; // 3 карточки в строке * 5 строк

const PaginatedCards = ({ posts, onPostClick, currentUserId, saved }) => {
  const [visibleItems, setVisibleItems] = useState(ITEMS_PER_LOAD);

  // Проверяем, что `posts` — это массив и фильтруем по `currentUserId`
  const filteredPosts = useMemo(() => {
    if (!Array.isArray(posts)) return []; // Защита от ошибки, если `posts` не массив
    return currentUserId != null
      ? posts.filter((post) => post.userId !== currentUserId)
      : posts;
  }, [posts, currentUserId]);

  const handleShowMore = () => {
    setVisibleItems((prev) => Math.min(prev + ITEMS_PER_LOAD, filteredPosts.length));
  };

  // Получаем текущие элементы с учетом `visibleItems`
  const currentItems = useMemo(() => filteredPosts.slice(0, visibleItems), [filteredPosts, visibleItems]);

  return (
    <div className="paginated-container">
      <div className="card-grid">
        {currentItems.length > 0 ? (
          currentItems.map((post, index) => (
            <div
              key={post.id || index} 
              style={{ cursor: 'pointer' }} 
            >
              <Card item={post} isSaved={saved} />
            </div>
          ))
        ) : (
          <p>No posts available</p> // Сообщение, если нет постов
        )}
      </div>
      {visibleItems < filteredPosts.length && (
        <button className="pagination-button" onClick={handleShowMore}>
          Show more...
        </button>
      )}
    </div>
  );
};

export default PaginatedCards;
